export function toRxMethod(method) {
    return method;
}
